import React, { useState, useEffect } from 'react';
import { Checkbox } from '@mui/material';

const TermsCheckbox = props => {
  const { checked: propsChecked, name, onChange, setValue = () => {} } = props;
  const [checked, setChecked] = useState(!!propsChecked);

  useEffect(() => {
    setChecked(propsChecked);
  }, [propsChecked]);

  return (
    <div style={{ position: 'relative', width: '37.5px' }}>
      <Checkbox
        name={name}
        checked={checked}
        onClick={
          onChange ||
          (() => {
            setChecked(p => !p);
            setValue(name, !checked);
          })
        }
        // className="custom-checkbox"
        sx={{ color: '#0F7F85', p: 0 }}
        style={{ opacity: 0, zIndex: 2 }}
        {...props}
      />
      <img
        src={checked ? '/images/check.svg' : '/images/uncheck.svg'}
        alt="checkbox"
        onClick={
          onChange ||
          (() => {
            setChecked(p => !p);
            setValue(name, !checked);
          })
        }
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          cursor: 'pointer',
        }}
      />
    </div>
  );
};

export default TermsCheckbox;
